module.exports = {
  path: 'app',
  getChildRoutes(partialNextState, cb) {
    require.ensure([], require => {
      cb(null, [
        require('./routes/dashboard/index'),
        require('./routes/services/index'),
        require('./routes/settings/index'),
        require('./routes/analytics/index'),
        require('./routes/alerts/index'),
        require('./routes/production/index'),
        require('./routes/consumption/index'),
        require('./routes/indicators/index'),
        require('./routes/processes/index'),
        require('./routes/airquality/index'),
      ]);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], require => {
      cb(null, require('./components/AppLayout'));
    });
  }
};



// WEBPACK FOOTER //
// ./routes/app/index.js